'use strict'

import React      from 'react'
import $          from 'jquery'
import ButtonPage from '../assets/button-page'

export default class Smoker extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      smoker: [
        'Yes',
        'No'
      ]
    }
  }

  isSmoker (x) {
    const { onChange, nextPage } = this.props

    window.ga('send', 'event', {
      eventCategory: 'Dental Question',
      eventAction: 'Click',
      eventLabel: 'Smoke'
    })

    onChange('smoker', {
      displayName: 'Smoker',
      value: $(x.target).attr('data-option'),
      pageRef: '',
      order: 4,
      displayInSummary: true
    })

    nextPage()
  }

  render () {
    const { smoker } = this.state
    const { summary } = this.props

    let activeValue = (summary['smoker']) ? summary['smoker'].value : ''

    return (
      <div className="smoker">
        <h2 className="header outline">Smoker?</h2>
        <h2 className="summary-question">Do you smoke?</h2>
        <ButtonPage buttons={smoker} onClick={this.isSmoker.bind(this)} activeValue={activeValue} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/form-segments/smoker.js